<template>
  <div class="loader-wrapper" :class="{ 'loader-background': isBackground }">
    <span v-show="isLoading" class="app-loader" :class="loaderClass"></span>
  </div>
</template>
  
<script>
  export default {
    props: {
      isLoading: {
        type: Boolean,
        default: true
      },
      isBackground: {
        type: Boolean,
        default: false
      },
      loaderClass: {
        type: String,
        default: 'default-loader'
      },
    },
  };
</script>
  
<style scoped>
.loader-wrapper {
  position: absolute;
  height: 100%;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
}

.loader-background {
  background-color: rgba(0, 0, 0, 0.5);
}

.app-loader {
  width: 30px;
  height: 30px;
  border-radius: 50%;
  animation: spin 0.8s linear infinite;
}

.default-loader {
  border: 3px solid #020076;
  border-top: 3px solid transparent;
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
</style>
